










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import DepartmentEditForm from '@/components/settings/department/DepartmentEditForm.vue';

@Component({
  components: {
    Header,
    DepartmentEditForm,
    Footer,
  },
})
export default class Department extends Vue {}
